export function formatCountdown(target?: string | null) {
  if (!target) return '--';

  const targetTime = new Date(target).getTime();
  const now = Date.now();
  const diff = Math.max(targetTime - now, 0);

  if (!Number.isFinite(diff) || Number.isNaN(diff)) {
    return '--';
  }

  const seconds = Math.floor(diff / 1000) % 60;
  const minutes = Math.floor(diff / (1000 * 60)) % 60;
  const hours = Math.floor(diff / (1000 * 60 * 60)) % 24;
  const days = Math.floor(diff / (1000 * 60 * 60 * 24));

  return [
    days ? `${days}d` : null,
    hours ? `${hours}h` : null,
    minutes ? `${minutes}m` : null,
    `${seconds}s`,
  ]
    .filter(Boolean)
    .join(' ');
}

/**
 * Check if a countdown timer has ended (reached 0)
 */
export function isCountdownEnded(target?: string | null): boolean {
  if (!target) return false;

  const targetTime = new Date(target).getTime();
  const now = Date.now();

  return now >= targetTime;
}
